module.exports = __webpack_public_path__ + "static/media/second-home.84bad685.svg";